<template>
	<multiselect
		v-model="value"
		class="generic-multiselect"
		:class="[
			longPlaceholder ? 'pt-1' : '',
			fullWidth ? 'full-width' : '',
			capitalize ? 'capitalize' : '',
			multiple ? 'full-height' : '',
			alertClass ? 'alert-class' : '',
			customClass,
		]"
		:options="options"
		:searchable="searchable"
		:close-on-select="closeOnSelect"
		:show-labels="true"
		:multiple="multiple"
		select-label=""
		selected-label=""
		deselect-label="Remover"
		track-by="id"
		label="name"
		:open-direction="direction"
		:placeholder="placeholder"
		:disabled="disabled"
		@input="changeInput"
		@change="changeInput"
		@search-change="saveInputValue"
		@open="clearValue"
		@close="closeInput"
	>
		<template slot="caret">
			<span class="arrow-caret" v-if="!plusIcon && showIcon">
				<MultiselectIcon :color="'#BECBDB'" />
			</span>
			<span class="arrow-caret-plus" v-else-if="plusIcon && showIcon">
				<PlusIcon :color="'#BECBDB'" />
			</span>
		</template>
		<template slot="noResult"> Não há opções para exibir. </template>
		<template slot="noOptions"> Não há opções para exibir. </template>
		<template v-if="infiniteScroll" slot="afterList">
			<div v-observe-visibility="reachedEndOfList" />
		</template>
	</multiselect>
</template>

<script>
import { mapActions } from 'vuex';
import { CLEAR_INVESTOR_LIST } from '@/store/modules/filters/investor/actions';
import MultiselectIcon from '@/components/shared/Icons/MultiselectIcon.vue';
import PlusIcon from '@/components/shared/Icons/PlusIcon.vue';

export default {
	name: 'GenericMultiselect',
	components: { MultiselectIcon, PlusIcon },
	props: {
		title: {
			default: 'generic',
		},
		placeholder: {
			required: true,
		},
		longPlaceholder: {
			default: false,
		},
		options: {
			required: true,
		},
		fullWidth: {
			default: false,
		},
		selectedOption: {
			default: null,
		},
		multiple: {
			default: false,
		},
		plusIcon: {
			default: false,
		},
		type: {
			default: null,
		},
		searchable: {
			default: false,
		},
		alertClass: {
			default: false,
		},
		capitalize: {
			default: false,
		},
		needType: {
			default: false,
		},
		disabled: {
			default: false,
		},
		showIcon: {
			default: true,
		},
		direction: {
			default: 'bottom',
		},
		cacheInput: {
			default: false,
		},
		infiniteScroll: {
			default: false,
		},
		clearOnOpen: {
			default: true,
		},
		customClass: {
			default: null,
		},
		previewSelectedMedias: {
			default: null,
		},
		closeOnSelect: {
			default: true,
		},
	},
	data: () => ({
		value: null,
		inputCache: '',
	}),
	mounted() {
		if (this.selectedOption) {
			this.value = { name: this.selectedOption.trim(), id: this.selectedOption.trim() };
		}
	},
	methods: {
		...mapActions('investor', {
			cleanInvestorList: CLEAR_INVESTOR_LIST,
		}),
		changeInput() {
			if (!this.multiple && !this.needType) {
				this.$emit('changeInput', this.value);
			} else if (!this.multiple && this.needType) {
				this.$emit('changeInput', { type: this.type, value: this.value });
			} else {
				this.$emit('changeInput', { type: this.type, value: this.value });
			}
		},
		saveInputValue(param) {
			this.$emit('requestSearch', param);

			if (param && this.cacheInput) {
				this.inputCache = param;
			}

			if (param == '' && this.type == 'investor') {
				setTimeout(() => {
					this.cleanInvestorList();
				}, 600);
			}
		},
		closeInput() {
			if (this.value && this.value.id) {
				return;
			}

			if (this.cacheInput && this.type == 'investor') {
				this.$emit('getCachedValue', this.inputCache);
			}
		},
		clearValue() {
			if (this.clearOnOpen) {
				this.value = null;
			}

			if (this.type == 'investor') {
				this.cleanInvestorList();
			}
		},
		setValue(param) {
			this.value = param;
		},
		getValue() {
			return this.value;
		},
		reachedEndOfList(reached) {
			if (reached) {
				this.$emit('nextPage');
			}
		},
	},
};
</script>

<style lang="scss">
@import 'GenericMultiselect.scss';
</style>
